import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getBooleanTypeAttr, getStrTypeAttr, removeAttrs, setCss } from '../../dom-utils';
import { clickoutside, CssTransition, warn, _Popper } from '../../mixins';
import { type, validComps } from '../../utils';
var DEFAULTDELAY = 80;
var STATEKEY = 'visibleState';
var ITEMKEY = 'itemKey';
var DROPENTERCLS = 'transition-drop-enter';
var DROPLEAVECLS = 'transition-drop-leave';
var VISIBLETIMER = null, EVENTTIMER = null;
var Dropdown = /** @class */ (function () {
    function Dropdown() {
        this.VERSION = 'v2.0';
        this.COMPONENTS = $el('r-dropdown', { all: true });
        this._create(this.COMPONENTS);
    }
    Dropdown.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'dropdown');
        var _a = Dropdown.prototype, _attrs = _a._attrs, _setVisible = _a._setVisible, _getChildDisabled = _a._getChildDisabled;
        var _b = _attrs(target), trigger = _b.trigger, placement = _b.placement;
        var DropdownRefElm = target.firstElementChild;
        var DropdownMenu = target.querySelector('r-dropdown-menu');
        var DropdownItem = DropdownMenu.querySelectorAll('r-dropdown-item');
        return {
            get visible() {
                return DropdownMenu.dataset[STATEKEY] === 'visible';
            },
            set visible(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _setVisible(target, DropdownMenu, newVal, placement);
            },
            events: function (_a) {
                var onClick = _a.onClick, onVisibleChange = _a.onVisibleChange, onClickOutside = _a.onClickOutside;
                // onVisibleChange
                var visibleChange = function () {
                    setTimeout(function () {
                        var visible = DropdownMenu.dataset[STATEKEY] === 'visible';
                        onVisibleChange && type.isFn(onVisibleChange, visible);
                    }, DEFAULTDELAY);
                };
                // onClick
                var itemClickEv = function (elem) {
                    if (_getChildDisabled(elem))
                        return false;
                    // @ts-ignore
                    var key = elem.dataset[ITEMKEY];
                    visibleChange();
                    onClick && type.isFn(onClick, key);
                };
                if (trigger === 'hover') {
                    bind(target, 'mouseenter', function () {
                        if (EVENTTIMER)
                            clearTimeout(EVENTTIMER);
                        EVENTTIMER = setTimeout(visibleChange, DEFAULTDELAY);
                    });
                    bind(target, 'mouseleave', function () {
                        if (EVENTTIMER)
                            clearTimeout(EVENTTIMER);
                        if (DropdownMenu.dataset[STATEKEY] === 'visible')
                            setTimeout(visibleChange, DEFAULTDELAY);
                    });
                }
                if (trigger === 'click' || trigger === 'contextMenu') {
                    onClickOutside &&
                        clickoutside(target, onClickOutside, DropdownMenu, STATEKEY, 'visible');
                }
                if (trigger === 'click') {
                    bind(DropdownRefElm, 'click', visibleChange);
                }
                if (trigger === 'contextMenu') {
                    bind(DropdownRefElm, 'contextmenu', visibleChange);
                }
                DropdownItem.forEach(function (child) { return bind(child, 'click', function () { return itemClickEv(child); }); });
            }
        };
    };
    Dropdown.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            if (!_this._correctCompositionNodes(node))
                return;
            var _a = _this._attrs(node), trigger = _a.trigger, placement = _a.placement, visible = _a.visible, stopPropagation = _a.stopPropagation;
            var DropdownMenu = node.querySelector('r-dropdown-menu');
            var DropdownItem = DropdownMenu.querySelector('r-dropdown-item');
            var key = _this._attrs(DropdownItem).key;
            _this._setVisible(node, DropdownMenu, visible, placement);
            _this._setChildKey(DropdownItem, key);
            _this._setStopPropagation(stopPropagation, node, DropdownMenu);
            _this._handleTrigger(trigger, placement, node, DropdownMenu);
            _this._handleItemClick(trigger, node, DropdownMenu, placement);
            removeAttrs(node, ['key', 'trigger', 'placement', 'visible', 'stop-propagation']);
        });
    };
    Dropdown.prototype._correctCompositionNodes = function (node) {
        var _a;
        if (((_a = node.firstElementChild) === null || _a === void 0 ? void 0 : _a.tagName) === 'R-DROPDOWN-MENU') {
            warn('👇 The first child element must be the reference element used to trigger the menu display hidden, not r-dropdown-menu');
            console.error(node);
            return false;
        }
        if (node.lastElementChild.tagName !== 'R-DROPDOWN-MENU') {
            warn('👇 The last child element tag must be made up of r-dropdown-menu');
            console.error(node);
            return false;
        }
        if (node.childElementCount > 2) {
            warn('👇 The number of child element nodes in this r-dropdown tag cannot exceed two');
            console.error(node);
            return false;
        }
        return true;
    };
    Dropdown.prototype._setStopPropagation = function (stop, node, child) {
        if (!stop)
            return;
        bind(node, 'click', function (e) { return e.stopPropagation(); });
        bind(child, 'click', function (e) { return e.stopPropagation(); });
    };
    Dropdown.prototype._handleTrigger = function (type, placement, node, child) {
        var _this = this;
        if (type === 'custom')
            return;
        var referenceElem = node.firstElementChild;
        // 触发菜单显示隐藏的引用元素如果是禁用状态则不做操作
        if (/disabled/.test(referenceElem.className))
            return;
        if (this._getChildDisabled(referenceElem))
            return;
        var showMenu = function () {
            if (VISIBLETIMER)
                clearTimeout(VISIBLETIMER);
            if (child.dataset[STATEKEY] === 'visible')
                return;
            VISIBLETIMER = setTimeout(function () { return _this._setVisible(node, child, true, placement); }, DEFAULTDELAY);
        };
        var hidenMenu = function () {
            if (VISIBLETIMER)
                clearTimeout(VISIBLETIMER);
            if (child.dataset[STATEKEY] === 'visible') {
                setTimeout(function () { return _this._setVisible(node, child, false, placement); }, DEFAULTDELAY);
            }
        };
        var clickIsShow = function (e) {
            e.stopPropagation();
            if (child.dataset[STATEKEY] === 'hidden') {
                showMenu();
            }
            else {
                hidenMenu();
            }
        };
        if (type === 'hover') {
            bind(node, 'mouseenter', showMenu);
            bind(node, 'mouseleave', hidenMenu);
        }
        // 点击菜单栏以外的地方隐藏
        if (type === 'click' || type === 'contextMenu') {
            clickoutside(node, hidenMenu);
        }
        if (type === 'click') {
            bind(referenceElem, 'click', function (e) { return clickIsShow(e); });
        }
        if (type === 'contextMenu') {
            bind(referenceElem, 'contextmenu', function (e) {
                e.preventDefault();
                clickIsShow(e);
            });
        }
    };
    Dropdown.prototype._handleItemClick = function (type, node, child, placement) {
        var _this = this;
        if (type === 'custom')
            return;
        var DropdownItems = child.querySelectorAll('r-dropdown-item');
        DropdownItems.forEach(function (item) {
            return bind(item, 'click', function () {
                if (_this._getChildDisabled(item))
                    return;
                _this._setVisible(node, child, false, placement);
            });
        });
    };
    Dropdown.prototype._setChildKey = function (child, key) {
        if (key) {
            child.dataset[ITEMKEY] = key;
            child.removeAttribute('key');
        }
    };
    Dropdown.prototype._setVisible = function (node, child, visible, placement) {
        var _a = Dropdown.prototype, _setPlacement = _a._setPlacement, _setTransitionDrop = _a._setTransitionDrop;
        if (visible) {
            child.dataset[STATEKEY] = 'visible';
            _setPlacement(node, child, placement);
            _setTransitionDrop('in', child);
        }
        else {
            child.dataset[STATEKEY] = 'hidden';
            setTimeout(function () {
                child.dataset[STATEKEY] === 'hidden' && _setTransitionDrop('out', child);
            }, 0);
        }
    };
    Dropdown.prototype._setPlacement = function (node, child, placement) {
        var popperPlacement = child.dataset['popperPlacement'] || placement;
        if (/^top|right-end|left-end/.test(popperPlacement)) {
            setCss(child, 'transformOrigin', 'center bottom');
        }
        if (/^bottom|right-start|left-start/.test(popperPlacement)) {
            setCss(child, 'transformOrigin', 'center top');
        }
        _Popper._newCreatePopper(node, child, placement, 0);
    };
    Dropdown.prototype._setTransitionDrop = function (type, child) {
        var transitionCls = type === 'in' ? { enterCls: DROPENTERCLS } : { leaveCls: DROPLEAVECLS };
        CssTransition(child, __assign(__assign({ inOrOut: type }, transitionCls), { rmCls: true, timeout: 290 }));
    };
    Dropdown.prototype._getChildDisabled = function (elem) {
        if (elem.getAttribute('disabled') === 'disabled' ||
            elem.getAttribute('disabled') === 'true' ||
            elem.getAttribute('disabled') === '') {
            return true;
        }
        return false;
    };
    Dropdown.prototype._attrs = function (node) {
        return {
            key: getStrTypeAttr(node, 'key', ''),
            trigger: getStrTypeAttr(node, 'trigger', 'hover'),
            placement: getStrTypeAttr(node, 'placement', 'bottom'),
            visible: getBooleanTypeAttr(node, 'visible'),
            stopPropagation: getBooleanTypeAttr(node, 'stop-propagation')
        };
    };
    return Dropdown;
}());
export default Dropdown;
